import { useState } from 'react';

const files = import.meta.glob<string>('./assets/chemical/*.png', {
  eager: true,
  query: '?url',
  import: 'default',
});

/**
 * 危化品场景的示意图。
 *
 * 图片全部是执行包提供的 AI 生成示意图：不是事故现场照片，不是设备产品实拍，
 * 也不构成设备性能或认证证据。页面不叠加可见图注；替代文字和页面研究声明仍保留来源性质。
 * 图片加载失败时，文字说明与资料链接仍然完整可读。
 */
export function ChemicalResearchImage({
  file,
  label,
}: {
  readonly file: string;
  readonly label: string;
}) {
  const [failed, setFailed] = useState<string | null>(null);
  const src = files['./assets/chemical/' + file];
  return (
    <figure className="scc-cap-image scc-chem-image" data-chemical-media={file}>
      {!src || failed === src ? (
        <div className="scc-image-fallback" role="status">
          示意图未能加载；{label}的文字说明与资料仍可阅读。
        </div>
      ) : (
        <img
          src={src}
          alt={label + '，AI生成示意图，非真实事故现场、非设备产品实拍'}
          decoding="async"
          loading="lazy"
          onError={() => setFailed(src)}
        />
      )}
    </figure>
  );
}
